import { Component, Input } from '@angular/core';

@Component({
  selector: 'doughnut-chart',
  templateUrl: './doughnut-chart.html',
  styleUrls: ['./doughnut-chart.scss'],
})

export class DoughnutChart {
  @Input('graphVaule') graphVaule: any;
  @Input('title') title: any;

  public doughnutChartData: number[];
  public doughnutChartType: string = 'doughnut';
  public polarAreaChartOptions: any = {
    maintainAspectRatio: false,
    responsive: true,
    tooltips: false,
  };

  public doughnutChartColours: any[];

  private valueColor: string;
  imgSrc: string = 'assets/images/inspection_icon_05.png';

  constructor() {}

  ngOnChanges() {
    let color;
    if (this.title !== '안구조절') {
      this.doughnutChartData = [this.graphVaule, 100 - this.graphVaule];
      if (this.graphVaule < 40) {
        color = { backgroundColor: ['#e60012', '#f9f2f2'] };
        this.valueColor = '#e60012';
      } else if (this.graphVaule < 80) {
        color = { backgroundColor: ['#fbb03b', '#fcf2e6'] };
        this.valueColor = '#fbb03b';
      } else {
        color = { backgroundColor: ['#33aeb6', '#edfcf8'] };
        this.valueColor = '#33aeb6';
      }
    } else {
      this.doughnutChartData = [0, 100];
      if (this.graphVaule !== 0) {
        color = { backgroundColor: ['#e60012', '#f9f2f2'] };
        this.valueColor = '#e60012';
        this.imgSrc = 'assets/images/inspection_icon_05.png';
      } else {
        color = { backgroundColor: ['#33aeb6', '#edfcf8'] };
        this.valueColor = '#33aeb6';
        this.imgSrc = 'assets/images/inspection_icon_04.png';
      }
    }
    this.doughnutChartColours = [color];
  }
}
